export default __webpack_public_path__ + "static/media/d020eb98-5c57-43d6-ba90-969907dc8186.ae01404f.webp";